import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify'; // import Toastify
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer2 from './Footer2';

const Contect = () => {
    const [formData, setFormData] = useState({
        Contact_Name: '',
        Contact_Email: '',
        Phone_Number: '',
        Contact_Message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email format regex
        const phoneRegex = /^[0-9]{10}$/; // 10-digit phone format

        if (!formData.Contact_Name.trim()) {
            toast.error("Please enter your name.");
            return;
        }

        if (!formData.Contact_Email.trim()) {
            toast.error("Please enter your email.");
            return;
        }

        if (!emailRegex.test(formData.Contact_Email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        if (!formData.Phone_Number.trim()) {
            toast.error("Please enter your phone number.");
            return;
        }

        if (!phoneRegex.test(formData.Phone_Number)) {
            toast.error("Please enter a valid 10-digit phone number.");
            return;
        }

        if (!formData.Contact_Message.trim()) {
            toast.error("Please enter your message.");
            return;
        }


        try {
            await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/contact`, formData);
            toast.success('Thank you for contacting!');
            setFormData({
                Contact_Name: '',
                Contact_Email: '',
                Phone_Number: '',
                Contact_Message: ''
            });
        } catch (error) {
            toast.error('Failed to send message.');
            // console.error(error);
        }
    };

    return (
        <>
            <Header />
            <div className="contect-page-main">
                <div className="container">
                    <div className="contect-page-inner-main">
                        <div className="contect-page-flex-main">
                            <div className="contect-page-child">
                                <div className="contect-page-child-inner-main">
                                    <img src="assets/img/contact1.jpg" alt="Contact" />
                                </div>
                            </div>
                            <div className="contect-page-child">
                                <div className="contect-page-child-inner-main">
                                    
                                    <p>Hello there!</p>
                                    <p>We Welcome inquires,questions about any pieces,commissions,collaborations and feedback,feel free to reach out us or connect with me on social media.</p>
                                    <p>follow along on instagram  to the latest projects and updates.we will get back to you within 24-48 hrs.</p>
                                    <p>Thank you!</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contect-wrapper">
                        <div className="contect-title">
                            <h2>Register Now</h2>
                        </div>
                        <form onSubmit={handleSubmit} className="contect-form">
                            <div className="contect-row">
                                <div className="contect-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        name="Contact_Name"
                                        value={formData.Contact_Name}
                                        onChange={handleChange}
                                    // spellCheck="false"
                                    />
                                </div>
                                <div className="contect-group">
                                    <label>E-mail</label>
                                    <input
                                        type="email"
                                        name="Contact_Email"
                                        value={formData.Contact_Email}
                                        onChange={handleChange}

                                    />
                                </div>
                            </div>

                            <div className="contect-group">
                                <label>Number</label>
                                <input
                                    type="text"
                                    name="Phone_Number"
                                    value={formData.Phone_Number}
                                    onChange={handleChange}

                                />
                            </div>

                            <div className="contect-group">
                                <label>Message</label>
                                <textarea
                                    name="Contact_Message"
                                    value={formData.Contact_Message}
                                    onChange={handleChange}

                                />
                            </div>

                            <button type="submit" className="contect-submit-btn">SEND</button>
                        </form>
                    </div>

                </div>
            </div>

            {/* <div className="happy-customers-section">
                <div className="container">
                    <h2 className="section-title">Our Happy Customers</h2>
                    <div className="slider-container">
                        <div className="slider-track">
                       
                            {[
                                { id: 1, name: "Ananya Iyer", text: "The custom resin tray I ordered is a masterpiece! Every guest asks about it." },
                                { id: 2, name: "Sameer Khan", text: "Participated in the ocean-pour workshop. Rengin is a great teacher, loved the vibe!" },
                                { id: 3, name: "Meera Patel", text: "High-quality finish and super fast shipping. The packaging was also very elegant." },
                                { id: 4, name: "Ruhana Joshi", text: "Highly recommend for unique housewarming gifts. Everyone loves the resin coasters!" }
                            ].concat([
                                { id: 1, name: "Ananya Iyer", text: "The custom resin tray I ordered is a masterpiece! Every guest asks about it." },
                                { id: 2, name: "Sameer Khan", text: "Participated in the ocean-pour workshop. Rengin is a great teacher, loved the vibe!" },
                                { id: 3, name: "Meera Patel", text: "High-quality finish and super fast shipping. The packaging was also very elegant." },
                                { id: 4, name: "Rohan Joshi", text: "Highly recommend for unique housewarming gifts. Everyone loves the resin coasters!" }
                            ]).map((customer, index) => (
                                <div className="customer-card-horizontal" key={index}>
                                    <div className="customer-img-box">
                                        <img src={`https://i.pravatar.cc/100?u=${customer.id}`} alt="Customer" />
                                    </div>
                                    <div className="customer-feedback-box">
                                        <p>"{customer.text}"</p>
                                        <h4>- {customer.name}</h4>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div> */}
            <ToastContainer />
            <Footer2 />
        </>
    );
};

export default Contect;
